import React, {Component} from 'react';

import Workflow from "../core/Workflow";
import axios from "axios";
import AuthService from "../../AuthService";


class Maintenance extends Component {
    constructor(props) {
        super(props);

        this.wowkflow = React.createRef();

        this.state = {
            workflowInitData : {
                WORKFLOW_ID: 2,
                PARAM_maintenanceId: this.props.match.params.maintenanceId
            },
            maintenanceId: this.props.match.params.maintenanceId,
        }
        
        this.coreChange = this.coreChange.bind(this);
        this.coreSubmit = this.coreSubmit.bind(this);
        this.coreExternalCall = this.coreExternalCall.bind(this);
    }

    coreChange(e) {
        if (e.target.name === "BLOCK_ITEM_2010101" && !(this.state.maintenanceId) && !!(e.target.value)) {
            document.location = "/admin/maintenance/" + e.target.value;
        }
    }

    async coreExternalCall(method) {
        if (method === "delete") {
            await axios.post(AuthService.getUrl('/deleteMaintenance'), {id: this.state.maintenanceId}, AuthService.getAuthHeader()).then(
                res => {
                    this.props.history.push('/admin/maintenances');
                }
            );
        }
        if (method === "close") {
            await axios.post(AuthService.getUrl('/endMaintenance'), {id: this.state.maintenanceId}, AuthService.getAuthHeader()).then(
                res => {
                    document.location = "/admin/maintenance/" + this.state.maintenanceId;
                }
            );
        }
        if (method === "leave") {
            this.props.history.push('/admin/maintenances');
        }
    }

    coreSubmit(data) {
        if (!!data) {
            data.screen.blocks[0].blockItems.map(blockItem => {
                if (blockItem.id === 200001) {
                    this.state.maintenanceId = blockItem.values[0];
                }
            });
        }
    }

    render() {
        return (
            <div className="responsiveForm">
                {!!(this.state.errorMessage) &&
                    <div className="errorMessage">
                        <span>{this.state.errorMessage}</span>
                    </div>
                }
                {!!(this.state.validMessage) &&
                    <div className="actionMessage">
                        <span>{this.state.validMessage}</span>
                    </div>
                }
                <Workflow   ref={this.wowkflow}
                            initData={this.state.workflowInitData}
                            onChange={this.coreChange}
                            onSubmit={this.coreSubmit}
                            externalCall={this.coreExternalCall}
                            primaryKey={this.state.maintenanceId}/>
            </div>
        );
    }
}

export default Maintenance;
